module.exports = __webpack_public_path__ + "./willy-illustration_597eeca6676df740051145cb6f48d79d.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2016/willy-illustration.png
// module id = 439
// module chunks = 0